<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container class="deletionWarning">
      <v-row>
        <v-col :cols="cols">
          <h1>
            {{ $t("basics.delete", { type: $t("basics." + type) }) }}
          </h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          {{ $t("messages.actionCantBeUndone") }}
        </v-col>
      </v-row>

      <v-row v-if="additionalMessage">
        <v-col>
          <b style="color: rgb(var(--v-theme-error))">{{ additionalMessage }}</b>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            large
            block
            flat
            class="primaryButton"
            @click="confirm()"
            ref="confirmButton"
          >
            <span>{{ $t("basics.confirm") }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "deletionWarning",

  props: ["refreshDisplay", "type", "additionalMessage"],
  emits: ["delete"],

  data() {
    return {};
  },

  watch: {
    refreshDisplay() {
      setTimeout(() => {
        this.$refs.confirmButton.$el.focus();
      }, 200);
    },
  },

  computed: {
    cols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 12;
        case "xl":
          return 12;
        case "xxl":
          return 12;
        default:
          return 12;
      }
    },
  },

  components: {},

  methods: {
    confirm() {
      this.$emit("delete");
    },
  },

  mounted() {},
};
</script>
